import React from "react";

export default function statusToelatingen(color){
	return (<svg id="Laag_4" viewBox="0 0 51 51" width="51px" height="80px">
		<g>
		<path fill="#009639" d="M30.778,7.654H13.89l-0.237,31.948h13.911v4.153l2.055-1.788l2.055,1.788v-4.153h5.676V14.224L30.778,7.654
		z M31.028,9.405l4.57,4.569h-4.57V9.405z M29.618,34.236c-0.35,0-0.683-0.071-0.994-0.186c-0.187-0.068-0.363-0.152-0.531-0.256
		c-0.189-0.118-0.371-0.251-0.529-0.408c-0.532-0.528-0.862-1.261-0.862-2.067c0-1.609,1.309-2.916,2.917-2.916
		c1.609,0,2.918,1.307,2.918,2.916c0,0.807-0.33,1.539-0.863,2.067c-0.158,0.157-0.338,0.29-0.529,0.408
		c-0.168,0.104-0.344,0.188-0.531,0.256C30.302,34.165,29.968,34.236,29.618,34.236 M28.624,41.427v-6.271
		c0.318,0.084,0.648,0.143,0.994,0.143s0.676-0.059,0.994-0.143v6.271l-0.994-0.865L28.624,41.427z M36.288,38.542h-4.615v-3.834
		c1.148-0.698,1.924-1.95,1.924-3.389c0-2.193-1.783-3.979-3.979-3.979c-2.193,0-3.978,1.785-3.978,3.979
		c0,1.438,0.774,2.69,1.923,3.389v3.834H14.721l0.222-29.826h15.025v6.318h6.32V38.542z"/>
		</g>
	</svg>);
}